module.exports = __webpack_public_path__ + "static/15-28437e8e4a0f0c07c5f1f69773863730.jpg";